<template>
  <div class="py-4 px-2">
    <GetOfferFormModal
      :offerid="offerid"
      :styleid="styleid"
      :vin="vin"
      :opengetoffer="GetOfferForm"
      :offercategoryid="'1'"
      :offerdesignid="offerdesignid"
      v-if="GetOfferForm"
      :consumereventid="consumereventid"
      @hideModal="GetOfferForm = false"
    ></GetOfferFormModal>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-7" v-if="!hideAuotmatedSpecials">
          <div v-if="special">
            <div v-if="!userPin">
              <div class="d-flex align-items-center">
                <h4 class="mr-4 my-0 font-weight-bold ft-16">Current Special</h4>
                <a :href="`${baseUrl}/specials`" class="text-color text-underline ft-12"
                  >View All Specials</a
                >
              </div>

              <div class="d-flex my-4">
                <div class="flex-1 px-2">
                  <div>
                    <img
                      v-if="useoverrides"
                      :src="
                        special.imageHandlerPath +
                        '&angle=03&autocrop=true&useoverrides=' +
                        useoverrides
                      "
                      class="img-fluid"
                      alt="Classic header"
                    />
                    <img
                      v-else
                      :src="special.imageHandlerPath + '&angle=03&autocrop=true'"
                      class="img-fluid"
                      alt="Classic header"
                    />
                  </div>
                  <div class="my-4">
                    <div>
                      <a
                        :href="`${baseUrl}/${special.vehicleFullName}`"
                        class="bgcolor-primary text-white d-inline-block px-5 py-2 rounded-buttons ft-14"
                        >View Details</a
                      >
                    </div>
                    <div class="mt-3">
                      <a
                        href=""
                        @click.prevent="openGetoffer(special.offerID, special.vin, special.styleID)"
                        style="border: 1px solid"
                        class="color-primary d-inline-block px-5 py-2 ft-14"
                        >Email Offer</a
                      >
                    </div>
                  </div>
                </div>
                <div class="flex-1" style="line-height: 2">
                  <div>
                    <div class="ft-12">
                      <strong>{{ special.offertype }} a {{ special.preText }}</strong>
                    </div>
                    <div>
                      <h5 class="font-weight-bold my-0" style="font-size: 15px">
                        {{ special.modelYear }}
                        {{ special.divisionName }}
                        {{ special.cfModelName }}
                        {{ special.trim }}
                      </h5>
                    </div>
                    <div class="d-flex align-items-end my-2">
                      <h3 class="color-primary my-0">
                        <strong>${{ special.amountText }}</strong>
                      </h3>
                      <span>&nbsp;/ mo</span>
                    </div>
                    <div class="ft-13 text-color">
                      <div>+Tax {{ special.offerText2 }}</div>
                      <div>{{ special.offerText3 }}</div>
                      <div>
                        Expires {{ special.endDate }}.
                        <a
                          @click.prevent="onOpenDisclaimer(special.disclaimerText)"
                          class="color-primary cursor-pointer"
                          >Disclosure</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-else>
              <div class="d-flex align-items-center">
                <h4 class="mr-4 my-0 font-weight-bold ft-16">Current Special</h4>
                <a :href="`${baseUrl}/specials`" class="text-color text-underline ft-12"
                  >View All Specials</a
                >
              </div>

              <div class="d-flex my-4">
                <div class="flex-1 px-2">
                  <div>
                    <img
                      v-if="useoverrides"
                      :src="
                        special.imageUrl + '&angle=03&autocrop=true&useoverrides=' + useoverrides
                      "
                      class="img-fluid"
                      alt="Classic header"
                    />
                    <img
                      v-else
                      :src="special.imageUrl + '&angle=03&autocrop=true'"
                      class="img-fluid"
                      alt="Classic header"
                    />
                  </div>
                  <div class="my-4">
                    <div>
                      <a
                        :href="`${baseUrl}/${special.fullName}`"
                        class="bgcolor-primary text-white d-inline-block px-5 py-2 ft-14"
                        >View Details</a
                      >
                    </div>
                  </div>
                </div>
                <div class="flex-1" style="line-height: 2">
                  <div>
                    <div class="ft-12">
                      <strong>{{ special.offerType }} a {{ special.preText }}</strong>
                    </div>
                    <div>
                      <h5 class="font-weight-bold my-0" style="font-size: 15px">
                        {{ special.year }}
                        {{ special.cfModelName }}
                        {{ special.trim }}
                      </h5>
                    </div>
                    <div class="d-flex align-items-end my-2">
                      <h3 class="color-primary my-0">
                        <strong>${{ special.payment }}</strong>
                      </h3>
                      <span>&nbsp;/ mo</span>
                    </div>
                    <div class="ft-13 text-color">
                      <div>
                        Expires
                        {{ special.expireDate }}.
                        <a
                          @click.prevent="onOpenDisclaimer(special.digitalDisclaimer)"
                          class="color-primary cursor-pointer"
                          >Disclosure</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-5 d-none d-xxl-block" v-if="coupons">
          <VSlickCarousel ref="slick" v-bind="slickOptions" prefix="slick">
            <div
              class="text-center py-3 px-3"
              v-for="coupon in coupons"
              :key="coupon.offerId"
              style="min-height: 237px"
            >
              <div class="header-coupons">
                <div class="text-center my-2">
                  <img
                    :src="`${libraryImagePath}?fileNameOrId=${coupon.imageId}&Width=80`"
                    class="m-auto"
                    alt="Classic header"
                  />
                </div>
                <h3 class="mt-1 mb-0" style="font-size: 15px">
                  {{ coupon.heading }}
                </h3>
                <div class="text-color">
                  <small>As low as</small>
                </div>
                <div>
                  <h3 style="font-size: 20px">
                    {{ coupon.amountText }}
                  </h3>
                </div>
                <div class="mt-2">
                  <a
                    href=""
                    @click.prevent="
                      onGetOfferClick(coupon.offerId, '', coupon.vin, '', coupon.offerDesignId)
                    "
                    class="bgcolor-primary text-white d-inline-block py-2 px-5"
                    >Save</a
                  >
                </div>
                <div class="ft-13 text-color my-2">
                  <a
                    href=""
                    @click.prevent="onOpenDisclaimer(coupon.disclaimerText)"
                    class="ft-13 text-color"
                    >Disclosure</a
                  >
                </div>
              </div>
            </div>
          </VSlickCarousel>
          <div class="text-center my-2">
            <a :href="`${baseUrl}/specials/servicespecials`" class="ft-12 text-color text-underline"
              >View All Service Coupons</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript" src="./CLassicHeaderMenuSpecials.js"></script>

<style>
em.primaryicon-right-arrow.slick-arrow {
  top: 40% !important;
  position: absolute;
  right: -4px;
  background: #fff;
  border: 1px solid #b7b7b7;
  color: #b7b7b7 !important;
}

.header-coupons a:focus {
  outline: 0px;
}

em.primaryicon-left-arrow.slick-arrow {
  top: 40% !important;
  position: absolute;
  left: -4px;
  background: #fff;
  border: 1px solid #b7b7b7;
  color: #b7b7b7 !important;
}
</style>

<style scoped>
.text-color {
  color: rgb(161, 161, 161);
}

.header-coupons {
  border: 1px dashed rgb(161, 161, 161);
}

.left-arrow {
  position: absolute;
  top: 40%;
  left: 0px;
  background: #f2f2f2;
}

.right-arrow {
  position: absolute;
  top: 40%;
  right: 0px;
  background: #f2f2f2;
}

.arrow-indicator {
  border: 1px solid rgb(161, 161, 161);
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  border-radius: 50%;
}
</style>
